import { SyntheticEvent, useState } from 'react';
import { scrollToElement } from '@99designs/browser';
import { Tab, Tabs } from '@99designs/emu';
import { TabId } from './TabId';

export type TabType = {
    id: TabId;
    label: string;
};

interface TabsMenuProps {
    tabs: TabType[];
    scrollOffsetTop?: number;
    defaultActiveTabId?: TabId;
}

export const DEFAULT_SCROLL_OFFSET_PX = 32;

export function TabsMenu({
    tabs,
    defaultActiveTabId,
    scrollOffsetTop = DEFAULT_SCROLL_OFFSET_PX,
}: TabsMenuProps) {
    const [activeTab, setActiveTab] = useState<TabId>(defaultActiveTabId || tabs[0].id);

    const tabClicked = (event: SyntheticEvent, id: TabId) => {
        event.preventDefault();
        setActiveTab(id);

        const element = document.getElementById(id);
        if (element) {
            scrollToElement(element, scrollOffsetTop);
        }
    };

    return (
        <Tabs aria-label="Secondary">
            {tabs.map(({ id, label }) => (
                <Tab
                    key={id}
                    active={id === activeTab}
                    href={`#${id}`}
                    onClick={(event) => tabClicked(event, id)}
                >
                    {label}
                </Tab>
            ))}
        </Tabs>
    );
}
